import { useAppSelector } from "integrations/redux/hooks"
import { selectWeatherPanel, selectWeatherTimeline } from "features/map/control/selectors"
import { useWeatherFrameTimes } from "../series/weatherFrameIndex"
import { displayedFrameTime } from "../series/frameResolution"
import { useLightningStrikesLoading } from "../lightning/lightningStrikesLayers"

export const useWeatherCurrentLoading = () => {
    const { mode } = useAppSelector(selectWeatherPanel)
    const { currentTime } = useAppSelector(selectWeatherTimeline)
    const frameTimesMs = useWeatherFrameTimes(mode)
    const strikesLoading = useLightningStrikesLoading()

    const loading =
        displayedFrameTime(frameTimesMs, Date.parse(currentTime)) === null ||
        (mode === "lightning" && strikesLoading)

    return { currentWeatherLoading: loading }
}
